const dev = {
  api: {
    BASEURL: "https://localhost:5040/",
  },
  intuit: {
    BASEURL: "https://sandbox.api.intuit.com/",
  },
  stripe: {
    publishableKey:
      "pk_test_51OULkgEj1MG0gIGaDUg4UJl4cq9v5KPawWJEDgO0J6bGHg2cakj5vph84shCcKdInN1TZQMOI2zTeAYu7D2GoP8G00PsBxfWnE",
  }
};

const prod = {
  api: {
    BASEURL: "https://backoffice-api.decibel130.com/",
  },
  intuit: {
    BASEURL: "https://api.intuit.com/",
  },
  stripe: {
    publishableKey:
      "pk_live_51OULkgEj1MG0gIGajYOgmUzNtqAMl9cyxfF6WcZBlNJSHn1p98SYn3VvQAr1SLPeZf4fi4z9p04xv7PqSwqFWjfe00oSlPBmFS",
  },
  googleMaps: {
    APIKEY: "AIzaSyDiLRjuNR7TItrAkeuFTMMjr4PPEuHS-Bw",
  }

};

let config;

switch (process.env.REACT_APP_ENV) {
  case "Development":
    config = dev;
    break;

  default:
    config = prod;
}

const defaultConfig = {
  graph: {
    BASEURL: "https://graph.microsoft.com/v1.0/",
  },
  TIMEOUT: 1500,
  GRAPH_SCOPES: ["openid", "profile", "User.Read", "GroupMember.Read.All"],
  googleMaps: {
    APIKEY: "AIzaSyDAZCTr-OiP9CN6byKzsj7tVIEsSwDTxaI",
  },
  ...config,
};

export default defaultConfig;
